// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2bd91d4c","563":"a077fed0","943":"b01ccd30"}[chunkId] + ".chunk.js";
};